var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"card"},[_c('k-bread-crumb',{attrs:{"list":_vm.bread},on:{"update:list":function($event){_vm.bread=$event}}}),_c('div',{staticClass:"common-container pd30"},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }